import React, { Component } from "react";
import { GlobalContext } from "../../../../../../utils/globalprovider";
class SubtitleRange extends Component {

    static contextType = GlobalContext;

    constructor(props) {
        super(props);

        const max = Math.max(1, props.maxSubtitles || 1);

        this.state = {
            firstSubtitle: "1",
            lastSubtitle: max.toString()
        };
    }

    getValues()
    {
        return {
            min: parseInt(this.state.firstSubtitle),
            max: parseInt(this.state.lastSubtitle),
        }
    }

    componentDidUpdate(prevProps) {

        if (prevProps.maxSubtitles !== this.props.maxSubtitles) {

            const max = Math.max(1, this.props.maxSubtitles || 1);

            this.setState({
                firstSubtitle: "1",
                lastSubtitle: max.toString()
            });

            this.notifyParent(1, max);
        }

    }

    notifyParent(first, last) {

        if (this.props.onChange) {
            this.props.onChange(first, last);
        }
    }

    validateFirst = () => {

        const max = this.props.maxSubtitles;

        let first = parseInt(this.state.firstSubtitle, 10);
        let last = parseInt(this.state.lastSubtitle, 10);

        if (isNaN(first))
            first = 1;

        if (isNaN(last))
            last = max;

        first = Math.max(1, Math.min(first, max));

        if (first > last)
            last = first;

        this.setState({
            firstSubtitle: first.toString(),
            lastSubtitle: last.toString()
        });

        this.notifyParent(first, last);
    }

    validateLast = () => {

        const max = this.props.maxSubtitles;

        let first = parseInt(this.state.firstSubtitle, 10);
        let last = parseInt(this.state.lastSubtitle, 10);

        if (isNaN(first))
            first = 1;

        if (isNaN(last))
            last = max;

        last = Math.max(1, Math.min(last, max));

        if (last < first)
            first = last;

        this.setState({
            firstSubtitle: first.toString(),
            lastSubtitle: last.toString()
        });

        this.notifyParent(first, last);
    }

    render() {

        const tstart = this.context.language == "fr"?"Premier sous-titre":"First subtitle";
        const tend = this.context.language == "fr"?"Dernier sous-titre":"Last subtitle";
        const tselected = this.context.language == "fr"?"Plage sélectionnée":"Selected range"

        const styles = {

            panel: {
                width: "100%",
                background: "#101010",
                border: "1px solid #3C3C3C",
                borderRadius: 10,
                padding: 5,
                color: "#F0F0F0",
                fontFamily: "Segoe UI, Arial, sans-serif",
                boxShadow: "0 6px 18px rgba(0,0,0,.35)",
                marginBottom: "5px"
            },

            row: {
                display: "grid",
                gridTemplateColumns: "1fr 110px",
                alignItems: "center",
                columnGap: 20,
                marginBottom: 2,
            },

            label: {
                fontSize: 12,
                color: "#D4D4D4"
            },

            input: {
                width: "100%",
                height: 34,
                boxSizing: "border-box",
                background: "#1E1E1E",
                color: "#FFFFFF",
                border: "1px solid #555",
                borderRadius: 5,
                padding: "0 10px",
                textAlign: "right",
                fontSize: 11,
                outline: "none"
            },

            separator: {
                borderTop: "1px solid #3F3F46",
            },

            footer: {
                color: "#9CDCFE",
                fontSize: 12
            }
        };

        return (

            <div style={styles.panel}>

                <div style={styles.row}>
                    <label style={styles.label}>
                        {tstart}
                    </label>

                    <input
                        type="text"
                        inputMode="numeric"
                        value={this.state.firstSubtitle}
                        style={styles.input}
                        onChange={(e) => this.setState({ firstSubtitle: e.target.value })}
                        
                        onBlur={ (e)=>{
                                this.validateFirst();
                                e.target.style.borderColor = "#555";
                                e.target.style.boxShadow = "0 0 0 0";
                            }
                        }
                        onFocus={(e) => {
                            e.target.style.borderColor = "#007ACC";
                            e.target.style.boxShadow = "0 0 6px rgba(0,122,204,.5)";
                            this.validateFirst();
                        }}
                        
                        onKeyDown={(e) => {
                            if (e.key === "Enter")
                                this.validateFirst();
                            e.stopPropagation();
                        }}
                    />
                </div>

                <div style={styles.row}>
                    <label style={styles.label}>
                        {tend}
                    </label>

                    <input
                        type="text"
                        inputMode="numeric"
                        value={this.state.lastSubtitle}
                        style={styles.input}
                        onChange={(e) => this.setState({ lastSubtitle: e.target.value })}
                        onBlur={ (e)=>{
                                this.validateLast();
                                e.target.style.borderColor = "#555";
                                e.target.style.boxShadow = "0 0 0 0";
                                
                            }
                        }
                        onFocus={(e) => {
                            e.target.style.borderColor = "#007ACC";
                            e.target.style.boxShadow = "0 0 6px rgba(0,122,204,.5)";
                            this.validateLast();
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter")
                                this.validateLast();
                            e.stopPropagation();                            
                        }}
                    />
                </div>

                <div style={styles.separator} />

                <div style={styles.footer}>
                    {tselected}: <b>{this.state.firstSubtitle}</b> → <b>{this.state.lastSubtitle}</b>
                </div>

            </div>
        );
    }
}

export default SubtitleRange;